<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Officetrax Info"
    size="sm"
  >
    <b-form
      novalidate
      @submit.stop.prevent="handleSubmit"
    >
      <b-row>
        <b-col>
          <b-alert
            :show="hasBaseServerErrors()"
            variant="danger"
            dismissible
          >
            <p
              class="mb-0"
              v-for="(error, index) in baseServerErrors"
              :key="index"
            >
              {{ error }}
            </p>
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="fieldLabels.close_out_number"
            label-for="work-order-officetrax-close_out_number"
          >
            <b-form-input
              id="work-order-officetrax-close_out_number"
              v-model="$v.form.close_out_number.$model"
              :state="$v.form.close_out_number.$dirty ? !$v.form.close_out_number.$error : null"
              type="text"
            />
            <b-form-invalid-feedback
              v-if="$v.form.close_out_number.$dirty"
              id="work-order-officetrax-close_out_number-feedback"
            >
              <!-- prettier-ignore -->
              <span v-if="!$v.form.close_out_number.maxLength"> The close out number must be less than {{ $v.formData.close_out_number.$params.maxLength.max + 1 }} characters.</span>
              <span v-if="!$v.form.close_out_number.serverFailed">{{ serverErrors.close_out_number }}</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-group
            :label="fieldLabels.scheduled_date"
            label-for="work-order-officetrax-scheduled_date"
            :class="{ 'is-invalid': $v.form.scheduled_date.$dirty && $v.form.scheduled_date.$error }"
          >
            <sfs-date-time-picker
              id="work-order-officetrax-scheduled_date"
              v-model="form.scheduled_date"
              :class="{ 'is-invalid': $v.form.scheduled_date.$dirty && $v.form.scheduled_date.$error }"
              :time-zone="value.location && value.location.time_zone"
            />
            <b-form-invalid-feedback
              v-if="$v.form.scheduled_date.$dirty"
              id="work-order-officetrax-scheduled_date-feedback"
            >
              <span v-if="!$v.form.scheduled_date.serverFailed">{{ serverErrors.scheduled_date }}</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <hr class="mt-4">

      <b-row>
        <b-col
          offset-lg="6"
          lg="3"
          order="2"
          order-lg="1"
        >
          <b-button
            variant="link-dark"
            block
            id="work-order-officetrax-close-button"
            @click="closeModal"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col
          lg="3"
          order="1"
          order-lg="2"
        >
          <b-button
            id="work-order-officetrax-submit-button"
            block
            type="submit"
            variant="primary"
            :disabled="processing"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </sfs-form-modal>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'WorkOrdersEditOfficetraxModal',
  mixins: [formMixin, formModalMixin],
  props: {
    value: Object,
  },
  data() {
    return {
      form: {
        close_out_number: this.value.integration_metadata?.close_out_number,
        scheduled_date: this.value.integration_metadata?.scheduled_date,
      },
      fieldLabels: { close_out_number: 'Close Out #', scheduled_date: 'Scheduled Date' },
      modalId: 'work-order-officetrax-modal',
    };
  },
  validations: {
    form: {
      close_out_number: {
        maxLength: maxLength(255),
        serverFailed() {
          return !this.hasServerErrors('close_out_number');
        },
      },
      scheduled_date: {
        serverFailed() {
          return !this.hasServerErrors('scheduled_date');
        },
      },
    },
  },
  methods: {
    handleSubmit() {
      if (this.hasFormErrors()) {
        return;
      }
      this.$workOrdersAPI
        .update(this.value.id, { integration_metadata: { close_out_number: this.form.close_out_number, scheduled_date: this.form.scheduled_date } })
        .then((workOrder) => {
          this.resetServerErrors();
          this.$v.$reset();
          this.$emit('input', workOrder);
          this.closeModal();
        })
        .catch((error) => {
          this.processServerErrors(error.response.data.errors);
        });
    },
  },
};
</script>
